/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Land_CertificateInputs */

const en_doc_type_land_certificate = /** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Certificate`)
};

const id_doc_type_land_certificate = /** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertifikat Tanah`)
};

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const es_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const fr_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const de_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const ja_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const zh_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const ar_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const it_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const ru_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const pt_doc_type_land_certificate = en_doc_type_land_certificate;

/** @type {(inputs: Doc_Type_Land_CertificateInputs) => LocalizedString} */
const ko_doc_type_land_certificate = en_doc_type_land_certificate;

/**
* | output |
* | --- |
* | "Land Certificate" |
*
* @param {Doc_Type_Land_CertificateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_land_certificate = /** @type {((inputs?: Doc_Type_Land_CertificateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Land_CertificateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_land_certificate(inputs)
	if (locale === "es") return es_doc_type_land_certificate(inputs)
	if (locale === "fr") return fr_doc_type_land_certificate(inputs)
	if (locale === "de") return de_doc_type_land_certificate(inputs)
	if (locale === "ja") return ja_doc_type_land_certificate(inputs)
	if (locale === "zh") return zh_doc_type_land_certificate(inputs)
	if (locale === "ar") return ar_doc_type_land_certificate(inputs)
	if (locale === "id") return id_doc_type_land_certificate(inputs)
	if (locale === "it") return it_doc_type_land_certificate(inputs)
	if (locale === "ru") return ru_doc_type_land_certificate(inputs)
	if (locale === "pt") return pt_doc_type_land_certificate(inputs)
	return ko_doc_type_land_certificate(inputs)
});